export const buildScheduleBandPayload = ({
    payload,
    masteryCenterId
}) => {
    return {
        ...payload,
        band_type: isMasteryCenter(payload.center_id, masteryCenterId) ? 2 : 1
    };
};

export const isMasteryCenter = (centerId, masteryCenterId) => {
    return Number(centerId) === Number(masteryCenterId);
};

export const shouldOpenOptionStep = action => {
    return [
        'doi-lich',
        'dat-lich',
        'them-lich-speaking'
    ].includes(action);
};

export const shouldShowAdminExamField = (
    enabled,
    centerId,
    masteryCenterId
) => {
    return Boolean(enabled && centerId && !isMasteryCenter(centerId, masteryCenterId));
};
